import type { ReactNode } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * Redirect for a legacy address that differs from a live one by its query
 * only (`/admin/profile-cleaning?type=exits_investments_to_complete` →
 * `/admin/exits-investments`, #762): renders `children` unless the query
 * parameter `param` equals `value`, in which case it replaces the entry with
 * `to`. Same home as `ParamRedirect`, for the same react-refresh reason.
 */
export default function QueryRedirect({
  param,
  value,
  to,
  children,
}: {
  param: string;
  value: string;
  to: string;
  children: ReactNode;
}) {
  const [searchParams] = useSearchParams();
  if (searchParams.get(param) === value) return <Navigate to={to} replace />;
  return <>{children}</>;
}
